<div *ngIf="isLoading" style="width:100%;height:100%;background-color: #fff;position: fixed;top:0;left:0;z-index:9999;">Loading...</div>
<ng-container *ngIf="canPlay">
    <app-player *ngIf="scenario && startStep&& !unavailable" [step]="startStep"
        [scenario]="scenario" [content]="startStep?.content" [width]="'window'" [options]="{}"></app-player>
    <div *ngIf="notFound" class="p-4">No scenario found...</div>
    <app-unavailable *ngIf="unavailable" [reason]="unavailableError"></app-unavailable>
</ng-container>
<div *ngIf="accessDenied" class="p-4">Access Denied</div>